import { render } from "./PostsLastImported.vue?vue&type=template&id=3cf0d13c&ts=true"
import script from "./PostsLastImported.vue?vue&type=script&lang=ts"
export * from "./PostsLastImported.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__